import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BreadCrumbsService {
  breadcrumbs = [];
  updateObservable = new BehaviorSubject("0");

  constructor() {
    this.breadcrumbs = JSON.parse(localStorage.getItem("paths"));
    if (!this.breadcrumbs) {
      this, (this.breadcrumbs = []);
    }
  }

  public addBreadCrumb(label: string, url: string) {
    var newArray = [];

    var duplicateFound = false;
    this.breadcrumbs.forEach((val) => {
      if (!duplicateFound) {
        duplicateFound = val.url == url;
        newArray.push(val);
      }
    });

    if (!duplicateFound) {
      newArray.push({
        label: label,
        url: url,
      });
    }

    this.breadcrumbs = [...newArray];

    localStorage.setItem("paths", JSON.stringify(this.breadcrumbs));

    this.updateBreadcrumb();
  }

  public addEmptyBreadcrumb(unique_name) {
    this.addBreadCrumb("", unique_name);
  }

  public updateBreadcrumb() {
    // this.ngDynamicBreadcrumbService.updateBreadcrumb(this.breadcrumbs);
    this.updateObservable.next(new Date().toString());
  }

  public resetBreadCrumb() {
    localStorage.setItem("paths", JSON.stringify([]));

    this.breadcrumbs = [];
    this.updateBreadcrumb();
  }
}
